export var SubmissionStatus;
(function (SubmissionStatus) {
    SubmissionStatus["BEATEN"] = "beaten";
    SubmissionStatus["BEATING"] = "beating";
    SubmissionStatus["ON_HOLD"] = "hold";
    SubmissionStatus["DROPPED"] = "dropped";
    SubmissionStatus["PLAN_TO_BEAT"] = "ptb";
})(SubmissionStatus || (SubmissionStatus = {}));
